import React, { useEffect, useRef, useState, useCallback } from "react";
import {
    format,
    subMonths,
    formatDistance,
    isAfter,
    isBefore,
    startOfDay,
    endOfDay,
} from "date-fns";
import { machineProfile } from "../../../api";
import { Card, CardBody, CardHeader, CardFooter } from "../../../components/card/card";
import OverlayTrigger from "react-bootstrap/OverlayTrigger";
import Popover from "react-bootstrap/Popover";
import ConfirmationDlg from "../../../components/ConfirmationDlg";
import Swal from "sweetalert2";
import "@sweetalert2/theme-dark/dark.css";
import {toast} from "react-toastify";
import ImageViewer from "../../../components/ImageViewer";

const isNewMonth = (data) => {
    const date = new Date(data);

    return date.getDate() == 1;
};

const getMonth = (data) => {
    return format(new Date(data), "MMM");
};

export const MachineElements = ({ machine, submited }) => {
    const [elements, setElements] = useState([]);
    const [openModal, setOpenModal] = useState(false);
    const [modalConfirm, setModalConfirm] = useState(false);
    const [selectedElement, setSelectedElement] = useState(null);
    const [selectedFile, setSelectedFile] = useState("");
    const [selectedImage, setSelectedImage] = useState(null)
    const [preview, setPreview] = useState();
    useEffect(()=>{
        console.log({machine})
        if(machine)setElements(machine.machine_elements)
    },[machine])

    const clickAdd = (element) => {
        setSelectedElement(element);
        setOpenModal(true);
    }
    const handleSubmit = async () => {
        if(!selectedFile) {
            toast.error("Please select a file to upload.");
            return;
        }
        const res = await machineProfile.uploadMachineElement(selectedElement.id,selectedElement.attachments, selectedFile);
        if (res.ok) {
            toast.success("File uploaded successfully.");
            setOpenModal(false);
            setSelectedFile(undefined);
            setPreview(undefined);
            submited()
            // Optionally, you can refresh the elements or fetch them again
            // setElements([...elements, res.data]);
        } else {
            toast.error("Failed to upload file.");
        }
    }
    const handleDelete = async (id)=>{
        const res = await machineProfile.deleteAttachment(selectedElement.id,selectedImage);
        if (res.ok) {
            toast.success("File deleted successfully.");
            setModalConfirm(false);
            setSelectedFile(undefined);
            setPreview(undefined);
            submited()
            // Optionally, you can refresh the elements or fetch them again
            // setElements([...elements, res.data]);
        } else {
            toast.error("Failed to delete file.");
        }
    }
    const onDeleteClick = async (id,element)=>{
        setSelectedImage(id)
        setSelectedElement(element);
        setModalConfirm(true)
    }
    const onSelectFile = async (e) => {
        if (!e.target.files || e.target.files.length === 0) {
            setSelectedFile(undefined);
            return;
        }

        // I've kept this example simple by using the first image instead of multiple
        setSelectedFile(e.target.files[0]);
    };

    useEffect(() => {
        if (!selectedFile) {
            setPreview(undefined);
            return;
        }
        //console.log({ selectedFile });
        const objectUrl = URL.createObjectURL(selectedFile);
        setPreview(objectUrl);
        //console.log({ objectUrl });
        // free memory when ever this component is unmounted
        return () => URL.revokeObjectURL(objectUrl);
    }, [selectedFile]);

    return (
        <div>
            <ConfirmationDlg
                open={modalConfirm}
                onClose={() => setModalConfirm(false)}
                onSubmit={handleDelete}
                btnSubmitText={"Delete"}
                btnCancelText={"Cancel"}
            >
                Are you sure you want to delete this picture?
            </ConfirmationDlg>
            <ConfirmationDlg
                open={openModal}
                onClose={() => setOpenModal(false)}
                onSubmit={handleSubmit}
                btnSubmitText={"Upload"}
                btnCancelText={"Cancel"}
            >
                <label htmlFor="files" style={{minHeight:"100px"}}>
                    {preview ? (
                        <>
                            <img src={preview} className="img-thumbnail" alt="" />
                            <div
                                style={{
                                    textAlign: "center",
                                    cursor: "pointer",
                                    marginTop: "5px",
                                }}
                            >
                                Change Photo <i className="fa fa-camera"></i>
                            </div>
                        </>
                    ) : (
                        <>
                            <div
                                style={{
                                    cursor: "pointer",
                                    position: "absolute",
                                    top: "50%",
                                    left: "50%",
                                    display: "flex",
                                    flexDirection: "column",
                                    justifyContent: "center",
                                    minHeight: "150px",
                                    alignItems: "center",
                                    transform: "translate(-50%, -50%)",
                                }}
                            >
                                <i className="fa fa-camera"></i>
                                <div>Add a Photo</div>
                            </div>
                        </>
                    )}
                </label>
                <input
                    id="files"
                    onChange={onSelectFile}
                    style={{ visibility: "hidden", position: "absolute" }}
                    type="file"
                    accept="image/png, image/jpeg"
                />
            </ConfirmationDlg>

            {
            elements.length > 0 ? (
                elements.map((element, index) => (
                    <Card key={index} className="mb-3">
                        <CardHeader>
                            {element.machine_element_name} - {element.deployments[0]?.sensor?.sensor_serial_number}
                        </CardHeader>
                        <CardBody>
                            <div className="d-flex justify-content-between">
                                Documents:
                            </div>
                           <div className={"row"}>
                               {
                                   Object.keys(element.attachments || {}).map((key) =>
                                       (
                                           <div className="col-12 col-md-6 col-lg-4 mb-2" key={key} style={{position:"relative"}}>
                                               <div className={"delete-attachment"} onClick={()=>{
                                                   onDeleteClick(key,element)
                                               }}>
                                                   <i style={{color:"red"}} className="fa fa-trash"></i>
                                               </div>
                                               <ImageViewer
                                                   src={element?.attachments[key]}
                                               />
                                           </div>
                                       )
                                      )
                               }
                               <div className={"col-md-3"}>
                                   <div className={"btn btn-outline-theme"} onClick={()=> clickAdd(element)}>
                                       <i className={"fa fa-add"}></i> Add Image
                                   </div>
                               </div>
                           </div>
                        </CardBody>

                    </Card>
                ))
            ) : (
                <p>No elements found for this machine.</p>
            )
        }
        </div>
    );
};
